import { cx } from '@linaria/core';
import { iconWrapper, wrapper, modifiers } from './custom.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

/**
 * Renders a custom toggle indicator, in case custom icons have been provided.
 */
function Custom(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.toggled && modifiers.toggled.className),
    children: [/*#__PURE__*/jsx("span", {
      className: cx(iconWrapper, "toggled"),
      children: props.toggledIcon
    }), /*#__PURE__*/jsx("span", {
      className: cx(iconWrapper, "default"),
      children: props.defaultIcon
    })]
  });
}

export { Custom };
//# sourceMappingURL=custom.js.map
